/**
 * @flow
 * @relayHash b0283ba18e41560a29b8c62e9f9a41fb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateContractEventSegmentInput = {
  clientMutationId?: ?string,
  contract_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_Contract_createContractEventSegmentMutationVariables = {|
  input: CreateContractEventSegmentInput
|};
export type Schedule_Contract_createContractEventSegmentMutationResponse = {|
  +createContractEventSegment: ?{|
    +new_contract_event_segment_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}
  |}
|};
export type Schedule_Contract_createContractEventSegmentMutation = {|
  variables: Schedule_Contract_createContractEventSegmentMutationVariables,
  response: Schedule_Contract_createContractEventSegmentMutationResponse,
|};
*/


/*
mutation Schedule_Contract_createContractEventSegmentMutation(
  $input: CreateContractEventSegmentInput!
) {
  createContractEventSegment(input: $input) {
    new_contract_event_segment_edge {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractEventSegmentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractEventSegment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateContractEventSegmentInput!"
      }
    ],
    "concreteType": "CreateContractEventSegmentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_contract_event_segment_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractEventSegmentEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractEventSegment",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "line1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "time_zone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "all_day",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "line2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "city",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "province",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "postal_code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "room",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Schedule_Contract_createContractEventSegmentMutation",
  "id": null,
  "text": "mutation Schedule_Contract_createContractEventSegmentMutation(\n  $input: CreateContractEventSegmentInput!\n) {\n  createContractEventSegment(input: $input) {\n    new_contract_event_segment_edge {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Schedule_Contract_createContractEventSegmentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Schedule_Contract_createContractEventSegmentMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '987ef798aed143f7bb0a3f874c7ee5e4';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/Schedule_Contract_createContractEventSegmentMutation.graphql.js